module.exports = __webpack_public_path__ + "img/d236835.png";